export const PIPELINE_DROP = 'PIPELINE_DROP';
export const PIPELINE_SET_APPLY = 'PIPELINE_SET_APPLY';
export const PIPELINE_TOGGLE_APPLY = 'PIPELINE_TOGGLE_APPLY';
export const PIPELINE_TOGGLE_FIELDS_LIST = 'PIPELINE_TOGGLE_FIELDS_LIST';
export const PIPELINE_TOGGLE_SAVED_LIST = 'PIPELINE_TOGGLE_SAVED_LIST';
export const PIPELINE_ADD_PIPE = 'PIPELINE_ADD_PIPE';
export const PIPELINE_DELETE_PIPE = 'PIPELINE_DELETE_PIPE';
export const PIPELINE_MOVE_PIPE = 'PIPELINE_MOVE_PIPE';
export const PIPELINE_SET_PIPE_TYPE = 'PIPELINE_SET_PIPE_TYPE';
export const PIPELINE_SET_PIPE_LOGIC = 'PIPELINE_SET_PIPE_LOGIC';
export const PIPELINE_SET_PIPES = 'PIPELINE_SET_PIPES';
export const PIPELINE_ADD_FIELD = 'PIPELINE_ADD_FIELD';
export const PIPELINE_DELETE_FIELD = 'PIPELINE_DELETE_FIELD';
export const PIPELINE_MOVE_FIELD = 'PIPELINE_MOVE_FIELD';
export const PIPELINE_SET_FIELD_IS = 'PIPELINE_SET_FIELD_IS';
export const PIPELINE_SET_FIELD_TYPE = 'PIPELINE_SET_FIELD_TYPE';
export const PIPELINE_SET_FIELD_CLAUSE = 'PIPELINE_SET_FIELD_CLAUSE';
export const PIPELINE_SET_FIELD_SORT = 'PIPELINE_SET_FIELD_SORT';
export const PIPELINE_ADD_GROUP = 'PIPELINE_ADD_GROUP';
export const PIPELINE_SET_PROGRESS = 'PIPELINE_SET_PROGRESS';
export const PIPELINE_SAVE = 'PIPELINE_SAVE';
export const PIPELINE_SET = 'PIPELINE_SET';
export const PIPELINE_DELETE = 'PIPELINE_DELETE';
